export default __webpack_public_path__ + "images/assets/b6ecb744a90c27f65b2f3753f2d385ac.svg";